module.exports = __webpack_public_path__ + "static/media/icomoon.1f808f56.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.eot?hujj0d
// module id = ./src/assets/fonts/icomoon.eot?hujj0d
// module chunks = 23